/* Próxima salida del envío semanal a Alemania. Se calcula en el navegador con la hora de Madrid
   (las páginas de Shopify se cachean, así que Liquid no sirve para "hoy").
   Regla: el próximo <diaSalida> ESTRICTAMENTE posterior a hoy. Hoy lunes → el lunes siguiente. */
(function (root) {
  var FMT = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' });
  var WD = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };

  function hoyMadrid(ahora) {
    var p = {};
    FMT.formatToParts(ahora).forEach(function (x) { p[x.type] = x.value; });
    return { utc: Date.UTC(+p.year, +p.month - 1, +p.day), wd: WD[p.weekday] };
  }

  function proximaSalida(ahora, diaSalida) {
    var h = hoyMadrid(ahora || new Date());
    var delta = ((diaSalida || 1) - h.wd + 7) % 7;
    if (delta === 0) delta = 7;
    return new Date(h.utc + delta * 864e5);
  }

  function dos(n) { return (n < 10 ? '0' : '') + n; }
  function formatoFecha(d) { return dos(d.getUTCDate()) + '-' + dos(d.getUTCMonth() + 1) + '-' + d.getUTCFullYear(); }

  function nombreFecha(d, locale) {
    return new Intl.DateTimeFormat(locale || 'es', { timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'long' }).format(d);
  }

  var api = { proximaSalida: proximaSalida, formatoFecha: formatoFecha, nombreFecha: nombreFecha };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.CDA_ENTREGA = api;
})(typeof window !== 'undefined' ? window : globalThis);
